/* eslint-disable @altermaind/no-useless-template-literals */
/* eslint-disable local-rules/template-literal */
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Svg, Typography } from '@altermaind/web/ui';
import { AlertBadge, Badge, CollapsableCard } from '@/_shared';
import { svg } from '@/_shared/assets/svg';
import { Chips, CreditViewValue, LayoutContext, VerticalStepper } from '@/_shared/components';
import { Form } from '@/_shared/components/Form';
import { EventType } from '@/swagger/constants/credits-enums';
import { ComponentShowcase } from '../components';

export const ComponentsScreen = () => {
  const { setLayout } = useContext(LayoutContext);

  const [activeChip, setActiveChip] = useState<string>('');
  const steps = [
    {
      title: 'Step 1',
      description: 'This is the description for step 1.',
    },
    {
      title: 'Step 2',
      description: 'This is the description for step 2.',
    },
  ];

  const { control } = useForm();

  useEffect(() => {
    setLayout({ title: 'core' });
  }, [setLayout]);

  return (
    <Box>
      <CollapsableCard isCollapsedOnDefault title='Alert Badge'>
        <Box>
          <ComponentShowcase
            code={`<AlertBadge iconName='lightBulb' type='primary' label='AlertBadge Primary' />`}
          >
            <AlertBadge iconName='lightBulb' type='primary' label='Primary' />
          </ComponentShowcase>
          <ComponentShowcase
            code={`<AlertBadge iconName='lightBulb' type='warning' label='AlertBadge Warning' />`}
          >
            <AlertBadge iconName='info' type='warning' label='Warning' />
          </ComponentShowcase>
          <ComponentShowcase
            code={`<AlertBadge iconName='lightBulb' type='transparent' label='AlertBadge Transparent' />`}
          >
            <AlertBadge iconName='info' type='transparent' label='Transparent' />
          </ComponentShowcase>
          <ComponentShowcase
            code={`<AlertBadge iconName='lightBulb' type='error' label='AlertBadge Error' />`}
          >
            <AlertBadge iconName='info' type='error' label='Error' />
          </ComponentShowcase>
          <ComponentShowcase
            code={`<AlertBadge iconName='lightBulb' type='success' label='AlertBadge Success' />`}
          >
            <AlertBadge iconName='info' type='success' label='Success' />
          </ComponentShowcase>
        </Box>
      </CollapsableCard>

      <CollapsableCard mt='s' isCollapsedOnDefault title='Badge'>
        <Box>
          <ComponentShowcase code={`<Badge label='Badge' />`}>
            <Badge label='Badge' />
          </ComponentShowcase>
        </Box>
      </CollapsableCard>

      <CollapsableCard mt='s' isCollapsedOnDefault title='Chips'>
        <Box>
          <ComponentShowcase code="<Chips setActiveChip={setActiveChip} activeChip={activeChip} data={['Soft skills', 'Hard skills']} />">
            <Box display='flex'>
              <Chips
                setActiveChip={setActiveChip}
                activeChip={activeChip}
                data={['Soft skills', 'Hard skills']}
              />
            </Box>
          </ComponentShowcase>
        </Box>
      </CollapsableCard>

      <CollapsableCard mt='s' isCollapsedOnDefault title='CreditViewValue'>
        <Box>
          <ComponentShowcase code='<CreditViewValue value={1} eventType={EventType.RECHARGE} />'>
            <CreditViewValue value={1} eventType={EventType.RECHARGE} />
          </ComponentShowcase>
          <ComponentShowcase code='<CreditViewValue value={1} eventType={EventType.VIDEO} />'>
            <CreditViewValue value={1} eventType={EventType.VIDEO} />
          </ComponentShowcase>
          <ComponentShowcase code='<CreditViewValue value={1} eventType={EventType.EXPIRATION} />'>
            <CreditViewValue value={1} eventType={EventType.EXPIRATION} />
          </ComponentShowcase>
        </Box>
      </CollapsableCard>

      <CollapsableCard mt='s' isCollapsedOnDefault title='Form'>
        <Box>
          <ComponentShowcase code='<Form.FormInput name="formInput" control={control} label="Form Input" placeholder="Placeholder" />'>
            <Form.FormInput
              name='formInput'
              control={control}
              label='Form Input'
              placeholder='Placeholder'
            />
          </ComponentShowcase>
        </Box>
      </CollapsableCard>

      <CollapsableCard mt='s' isCollapsedOnDefault title='SVG'>
        <Box>
          <ComponentShowcase code='<Svg name={"name"} />'>
            <Box display='grid' gridTemplateColumns={`repeat(${8}, 1fr)`} style={{ gap: '16px' }}>
              {Object.keys(svg).map(name => (
                <Box
                  key={name}
                  display='flex'
                  flexDirection='column'
                  justifyContent='center'
                  alignItems='center'
                >
                  <Svg name={name as keyof typeof Svg} />
                  <Typography mt='xxs' variant='p2/light'>
                    {name}
                  </Typography>
                </Box>
              ))}
            </Box>
          </ComponentShowcase>
        </Box>
      </CollapsableCard>

      <CollapsableCard mt='s' isCollapsedOnDefault title='VerticalStepper'>
        <Box>
          <ComponentShowcase code='<VerticalStepper noBorder steps={steps} />'>
            <VerticalStepper noBorder steps={steps} />
          </ComponentShowcase>
        </Box>
      </CollapsableCard>
    </Box>
  );
};
